/* eslint-disable */
// French translation. Keys must mirror the `en` dictionary in strings.js.

export const FR_RISK_LABELS = {
  "Very High": "Très élevé",
  High: "Élevé",
  "Intermediate-High": "Intermédiaire-élevé",
  Intermediate: "Intermédiaire",
  Low: "Faible",
  "Very Low": "Très faible",
};

export const FR = {
  "layout.subtitle": "Simulateur Clinique · v1.0.0",
  "layout.poweredBy": "Powered by",
  "layout.signIn": "Se connecter",
  "layout.logout": "Déconnexion",
  "nav.overview": "Présentation",
  "nav.simulator": "Simulateur",
  "nav.configuration": "Configuration",
  "nav.api": "API",
  "footer.source": "Source : Simulatore SEPSI_EMO (20250822) · LDA + Arbres de décision",
  "footer.tech": "Déployable sur Azure · Configuration JSON · Persistance MongoDB",
  "lang.label": "Langue",

  "ov.kicker": "Aide à la Décision Clinique · 01",
  "ov.titleA": "Sepsi Index Framework",
  "ov.titleB": "plateforme de calcul.",
  "ov.description":
    "Un framework conçu pour distinguer les cas de Sepsis des autres maladies ou infections à partir des analytes de l'hémogramme.",
  "ov.openSimulator": "Ouvrir le Simulateur Patient →",
  "ov.editConfig": "Modifier la Configuration",
  "ov.activeConfig": "Configuration Active",
  "ov.card.variables": "Variables",
  "ov.card.variables.sub": "valeurs hématologiques en entrée",
  "ov.card.classes": "Classes LDA",
  "ov.card.classes.sub": "Pas de SEPSIS + 4 jours d'alerte",
  "ov.card.rules": "Règles de Décision",
  "ov.card.rules.sub": "règles feuilles de l'arbre",
  "ov.card.version": "Version de Configuration",
  "ov.sponsor.label": "Un projet soutenu par",
  "ov.sponsor.tagline": "AI-Care for a better life",
  "ov.step": "Étape",
  "ov.step1.title": "Saisie des données cliniques",
  "ov.step1.body":
    "Le médecin accède à l'application sur mobile (APP) ou sur ordinateur (webapp) et saisit les valeurs de l'hémogramme du patient, déjà disponibles dès la phase initiale de l'évaluation aux Urgences.",
  "ov.step2.title": "Calcul de l'indicateur prédictif",
  "ov.step2.body":
    "Le système traite automatiquement les données au moyen de trois modèles prédictifs indépendants. Le médecin peut consulter et sélectionner le modèle jugé le plus cohérent avec le profil clinique du patient, en gardant le plein contrôle de la décision.",
  "ov.step3.title": "Résultat clinique et aide à la décision",
  "ov.step3.bodyIntro": "L'application fournit :",
  "ov.step3.bullet1": "un pourcentage de probabilité de sepsis,",
  "ov.step3.bullet2":
    "des alertes de risque pour les 4 premiers jours suivant l'analyse, offrant un soutien précoce à la stratification du risque, sans remplacer le jugement clinique.",

  "sim.kicker": "Section 02",
  "sim.title": "Simulateur Patient",
  "sim.description":
    "Saisissez les 20 valeurs hématologiques, choisissez un préréglage ou modifiez champ par champ. À chaque calcul, l'API renvoie l'Analyse Discriminante Linéaire, l'Arbre de Décision et le risque combiné.",
  "sim.sponsoredBy": "Soutenu par",
  "sim.reset": "Réinitialiser",
  "sim.calculate": "Calculer le Risque de Sepsis →",
  "sim.calculating": "Calcul en cours…",
  "sim.awaiting.title": "En attente du calcul",
  "sim.awaiting.body":
    "Remplissez le formulaire (ou chargez un préréglage) et cliquez sur Calculer pour afficher l'analyse discriminante, le chemin de l'arbre de décision et la classe de risque combinée.",
  "sim.group.neutrophils": "Neutrophiles",
  "sim.group.lymphocytes": "Lymphocytes",
  "sim.group.monocytes": "Monocytes",
  "sim.group.rdw": "Variabilité érythrocytaire (RDW)",
  "sim.group.ratios": "Rapports",
  "sim.group.platelets": "Plaquettes",
  "sim.result.combined": "Probabilité Combinée de Sepsis",
  "sim.result.compare": "Comparaison des méthodologies",
  "sim.result.perClass": "Probabilité par classe (combinée)",
  "sim.result.path": "Chemin de l'arbre de décision · nœud",
  "sim.method.lda": "Discriminante Linéaire",
  "sim.method.tree": "Arbres de Décision",
  "sim.method.combined": "Combiné (MAX)",
  "sim.result.txId": "ID de Transaction",
  "sim.result.txIdHint": "Conservez cet ID dans le dossier du patient pour valider la prédiction ultérieurement.",
  "sim.result.copy": "Copier",
  "sim.result.copied": "Copié",
  "sim.patientRef.label": "Référence patient (facultatif)",
  "sim.patientRef.placeholder": "ex. n° de dossier ou ID interne",
  "sim.patientRef.help": "Facultatif. Enregistré avec la transaction : vous pourrez retrouver cette prédiction depuis l'Historique en recherchant par référence.",
  "sim.result.patientRef": "Référence patient",

  "cfg.kicker": "Section 03",
  "cfg.title": "Configuration",
  "cfg.description":
    "Modifiez les poids, les feuilles de l'arbre de décision, les seuils de risque et les utilisateurs autorisés. Les modifications sont enregistrées dans MongoDB.",
  "cfg.import": "Importer Excel…",
  "cfg.export": "Exporter JSON",
  "cfg.reset": "Rétablir les valeurs par défaut",
  "cfg.save": "Enregistrer",
  "cfg.saving": "Enregistrement…",
  "cfg.saved": "Configuration enregistrée",
  "cfg.resetDone": "Configuration par défaut rétablie",
  "cfg.extracted": "Extrait de l'Excel — cliquez sur Enregistrer pour l'activer",
  "cfg.tab.lda": "Poids discriminants",
  "cfg.tab.tree": "Arbre de décision",
  "cfg.tab.thresholds": "Seuils de risque",
  "cfg.tab.users": "Utilisateurs",
  "cfg.tab.apitokens": "Jetons API",
  "tok.title": "Jetons API",
  "tok.subtitle": "Jetons bearer longue durée pour les clients serveur à serveur (ex. une Azure Function). Chaque jeton est lié à une adresse e-mail « robot » qui doit déjà figurer dans la liste autorisée — la retirer désactive instantanément tous les jetons émis pour cette identité.",
  "tok.create.heading": "Générer un nouveau jeton API",
  "tok.create.name": "Nom",
  "tok.create.name.placeholder": "ex. Azure Function — Production",
  "tok.create.email": "E-mail robot",
  "tok.create.email.help": "Choisissez une identité déjà présente dans la liste autorisée. L'e-mail robot apparaîtra dans chaque ligne du journal clinique générée par ce jeton.",
  "tok.create.email.empty": "Aucun e-mail dans la liste autorisée. Ajoutez-en un d'abord depuis l'onglet Utilisateurs.",
  "tok.create.ttl": "Validité",
  "tok.create.ttl.30": "30 jours",
  "tok.create.ttl.90": "90 jours",
  "tok.create.ttl.365": "1 an",
  "tok.create.ttl.none": "Sans expiration (révocation uniquement)",
  "tok.create.submit": "Générer le jeton",
  "tok.create.submitting": "Génération…",
  "tok.minted.title": "Jeton créé — copiez-le maintenant",
  "tok.minted.warning": "C'est la seule fois où le jeton complet sera affiché. Enregistrez-le dans un gestionnaire de secrets (Azure Key Vault, AWS Secrets Manager, etc.) avant de fermer ce bandeau.",
  "tok.minted.copy": "Copier le jeton",
  "tok.minted.copied": "Copié",
  "tok.minted.dismiss": "Je l'ai enregistré — fermer",
  "tok.list.heading": "Jetons existants",
  "tok.list.empty": "Aucun jeton API émis pour le moment.",
  "tok.col.name": "Nom",
  "tok.col.robot": "E-mail robot",
  "tok.col.created": "Créé",
  "tok.col.expires": "Expire",
  "tok.col.lastUsed": "Dernière utilisation",
  "tok.col.status": "Statut",
  "tok.status.active": "Actif",
  "tok.status.revoked": "Révoqué",
  "tok.status.expired": "Expiré",
  "tok.noExpiry": "Sans expiration",
  "tok.never": "Jamais",
  "tok.revoke": "Révoquer",
  "tok.revoke.confirm": "Révoquer ce jeton ? Les clients qui l'utilisent recevront immédiatement une erreur 401.",
  "cfg.lda.variable": "Variable",
  "cfg.lda.intercept": "Constante",
  "cfg.tree.node": "Nœud",
  "cfg.tree.count": "Effectif",
  "cfg.thr.threshold": "Seuil (≥)",
  "cfg.thr.labelEn": "Libellé (EN)",
  "cfg.thr.labelIt": "Libellé (IT)",
  "cfg.thr.labelFr": "Libellé (FR)",
  "cfg.thr.labelEs": "Libellé (ES)",
  "cfg.users.title": "Utilisateurs autorisés",
  "cfg.users.active": "actifs",
  "cfg.users.you": "Vous · non supprimable",
  "cfg.users.remove": "Retirer",
  "cfg.users.invite": "Inviter un nouvel utilisateur",
  "cfg.users.help":
    "Ajoutez une adresse e-mail Google. L'utilisateur pourra se connecter via Google et accéder aux pages protégées dès que son e-mail figure dans cette liste. Retirer un e-mail révoque les connexions futures (les jetons existants expirent sous 12 h).",
  "cfg.users.add": "Ajouter à la liste",
  "cfg.users.signedIn": "Actuellement connecté en tant que",
  "cfg.users.loading": "Chargement des utilisateurs…",
  "cfg.errors.invalidEmail": "Format d'e-mail invalide",
  "cfg.errors.dup": "E-mail déjà présent dans la liste",
  "cfg.errors.removeSelf": "Vous ne pouvez pas retirer votre propre adresse",
  "cfg.users.updated": "Utilisateurs autorisés mis à jour",
  "cfg.loading": "Chargement de la configuration…",

  "login.kicker": "Accès restreint",
  "login.titleA": "Connectez-vous pour accéder",
  "login.titleB": "à la plateforme.",
  "login.description":
    "Le Simulateur et la Configuration sont réservés à une liste d'adresses e-mail autorisées. Seule la Présentation publique est accessible sans authentification.",
  "login.step1": "Cliquez sur Se connecter avec Google",
  "login.step2": "Autorisez dans la fenêtre Google",
  "login.step3": "Votre e-mail est comparé à la liste du serveur",
  "login.step4": "En cas de succès, vous êtes redirigé vers votre destination",
  "login.provider": "Google OAuth 2.0",
  "login.cta": "Se connecter avec Google",
  "login.signingIn": "Connexion en cours…",
  "login.note":
    "Nous lisons uniquement votre adresse e-mail. Votre e-mail doit figurer dans la liste autorisée pour obtenir un jeton de session.",
  "login.errors.failed": "Échec de la connexion",
  "login.errors.cancelled": "La connexion Google a été annulée",

  "auth.checking": "Vérification de l'authentification…",

  "nav.transactions": "Historique",
  "tx.kicker": "Audit Clinique · 05",
  "tx.title": "Historique des transactions",
  "tx.description":
    "Chaque prédiction est enregistrée avec l'entrée, la sortie et l'appelant. En tant qu'administrateur, vous pouvez valider chaque cas comme Correct ou Incorrect afin de soutenir l'analyse rétrospective de la précision et l'ajustement futur du modèle.",
  "tx.filter.all": "Toutes",
  "tx.filter.pending": "En attente",
  "tx.filter.yes": "Correctes (OUI)",
  "tx.filter.no": "Incorrectes (NON)",
  "tx.filter.caller": "Filtrer par e-mail de l'appelant…",
  "tx.filter.id": "Rechercher par ID de transaction…",
  "tx.filter.ref": "Rechercher par référence patient…",
  "tx.filter.clear": "Effacer",
  "tx.export.csv": "Exporter CSV",
  "tx.export.csv.exporting": "Exportation…",
  "tx.export.csv.help": "Télécharge toutes les transactions correspondant aux filtres actifs au format CSV (compatible Excel, UTF-8 avec BOM). Inclut une colonne par variable patient.",
  "tx.empty": "Aucune transaction enregistrée. Lancez un calcul depuis le Simulateur (ou appelez POST /api/calculate) pour enregistrer la première.",
  "tx.empty.search": "Aucune transaction ne correspond à votre recherche.",
  "tx.col.id": "ID de Transaction",
  "tx.col.ref": "Réf. patient",
  "tx.col.when": "Date",
  "tx.col.caller": "Appelant",
  "tx.col.prob": "P(SEPSIS)",
  "tx.col.class": "Classe de risque",
  "tx.col.validation": "Validation",
  "tx.col.actions": "",
  "tx.copyId": "Copier l'ID de transaction",
  "tx.detail.expand": "Afficher les détails",
  "tx.detail.collapse": "Masquer les détails",
  "tx.delete": "Supprimer",
  "tx.delete.confirm": "Supprimer définitivement cette transaction ? Cette action est irréversible — la prédiction sera retirée du journal clinique et des statistiques de précision.",
  "tx.detail.input": "Entrée",
  "tx.detail.output": "Sortie (combinée)",
  "tx.detail.path": "Chemin de l'arbre de décision",
  "tx.validation.pending": "En attente",
  "tx.validation.yes": "Correct",
  "tx.validation.no": "Incorrect",
  "tx.validation.markYes": "Marquer comme Correct",
  "tx.validation.markNo": "Marquer comme Incorrect",
  "tx.validation.clear": "Réinitialiser",
  "tx.validation.notes": "Notes (facultatif)",
  "tx.validation.notesPh": "Observations cliniques, référence du dossier, suivi…",
  "tx.validation.save": "Enregistrer la validation",
  "tx.validation.by": "Validé par",
  "tx.validation.at": "le",
  "tx.stats.total": "Total",
  "tx.stats.pending": "En attente",
  "tx.stats.yes": "Correctes",
  "tx.stats.no": "Incorrectes",
  "tx.loading": "Chargement des transactions…",
  "tx.refresh": "Actualiser",

  "nav.accuracy": "Précision",
  "acc.kicker": "Performance du Modèle · 06",
  "acc.title": "Précision rétrospective",
  "acc.description":
    "Précision en temps réel du modèle prédictif, basée sur les validations OUI/NON enregistrées dans l'Historique. Utilisez-la pour surveiller la dérive des performances, identifier les classes de risque les plus faibles et orienter le réajustement du modèle.",
  "acc.refresh": "Actualiser",
  "acc.headline.label": "Précision validée",
  "acc.headline.empty": "Aucun cas validé pour le moment — rendez-vous dans l'Historique et validez quelques transactions pour alimenter le tableau de bord.",
  "acc.headline.basis": "basé sur",
  "acc.headline.basis2": "cas validés",
  "acc.summary.total": "Transactions totales",
  "acc.summary.validated": "Validées",
  "acc.summary.pending": "En attente de revue",
  "acc.summary.coverage": "Couverture",
  "acc.byClass.title": "Précision par classe de risque",
  "acc.byClass.empty": "Validez au moins un cas pour afficher la répartition par classe de risque.",
  "acc.byClass.class": "Classe de risque",
  "acc.byClass.cases": "Cas",
  "acc.byClass.correct": "Corrects",
  "acc.byClass.incorrect": "Incorrects",
  "acc.byClass.accuracy": "Précision",
  "acc.byDay.title": "N derniers jours",
  "acc.byDay.subtitle": "Précision quotidienne (seuls les jours avec des validations sont affichés)",
  "acc.byDay.empty": "Aucun cas validé sur cette période.",
  "acc.byCaller.title": "Principaux appelants",
  "acc.byCaller.empty": "Aucun appelant avec des cas validés pour le moment.",
  "acc.byCaller.email": "Appelant",
  "acc.byCaller.cases": "Cas",
  "acc.byCaller.accuracy": "Précision",
  "acc.window.7": "7 jours",
  "acc.window.30": "30 jours",
  "acc.window.90": "90 jours",
  "acc.window.all": "Tout",
  "acc.loading": "Calcul des métriques…",

  "docs.kicker": "Référence Développeur · 04",
  "docs.title": "API pour clients HTTP",
  "docs.intro":
    "Le Sepsi Index Framework expose une API REST. Tout client HTTP (curl, Postman, Python, un service backend…) peut calculer le risque de sepsis après s'être authentifié avec une **identité Google** figurant dans la liste des utilisateurs autorisés.",
  "docs.interactive.title": "Documentation interactive",
  "docs.interactive.body":
    "Le schéma OpenAPI 3.1 complet est généré automatiquement. Utilisez Swagger UI pour tester chaque endpoint en direct (collez un jeton ID Google dans **Authorize**), ou importez le JSON brut dans Postman, Insomnia ou un générateur de code OpenAPI.",
  "docs.interactive.swagger": "Ouvrir Swagger UI",
  "docs.baseUrl": "URL de base",
  "docs.auth.title": "Authentification",
  "docs.auth.intro":
    "Transmettez un jeton Bearer dans l'en-tête `Authorization`. Le serveur accepte **deux formats équivalents** de jeton :",
  "docs.auth.google.title": "Jeton ID Google (recommandé pour les clients HTTP)",
  "docs.auth.google.body":
    "— tout jeton ID émis par l'OAuth de Google pour notre client ID ({clientId}). Il doit être signé en RS256, avoir un e-mail vérifié, et l'e-mail doit figurer dans la liste autorisée.",
  "docs.auth.app.title": "JWT de l'application",
  "docs.auth.app.body":
    "— le jeton HS256 de courte durée renvoyé par `POST /api/auth/google` (utilisé par la SPA après la fenêtre de connexion Google).",
  "docs.auth.errors":
    "En cas de `401`, la réponse contient `WWW-Authenticate: Bearer`. Un `403` signifie que le jeton est valide mais que l'e-mail **ne figure pas dans la liste autorisée** — demandez à un administrateur de l'ajouter depuis la page **Configuration → Utilisateurs**.",
  "docs.endpoints.title": "Endpoints",
  "docs.col.method": "Méthode",
  "docs.col.path": "Chemin",
  "docs.col.auth": "Auth",
  "docs.col.desc": "Description",
  "docs.bearerRequired": "Bearer requis",
  "docs.public": "public",
  "docs.ep.calculate": "Calcule le risque de sepsis pour un patient.",
  "docs.ep.health": "Sonde de disponibilité (nombre de variables/règles/version).",
  "docs.ep.config": "Renvoie la configuration active (lecture seule).",
  "docs.ep.examples": "Trois cas patients prédéfinis (risque faible / moyen / élevé).",
  "docs.ep.configPut": "Remplace la configuration active (admin).",
  "docs.ep.configReset": "Rétablit le modèle par défaut (conserve la liste autorisée).",
  "docs.ep.configExtract": "Extrait une configuration d'un Excel de référence (upload multipart).",
  "docs.ep.emailsGet": "Liste les utilisateurs autorisés.",
  "docs.ep.emailsPut": "Remplace la liste autorisée.",
  "docs.payload.title": "Corps de la requête — POST /api/calculate",
  "docs.payload.body":
    "Le corps contient un unique objet `patient` avec les 20 valeurs hématologiques. Les valeurs manquantes sont traitées comme zéro dans le modèle LDA et ignorent les conditions correspondantes de l'arbre de décision.",
  "docs.curl.title": "Exemple · curl + gcloud",
  "docs.curl.body":
    "La solution la plus simple : une fois connecté à gcloud (`gcloud auth login`), vous pouvez générer des jetons ID de courte durée associés à notre client OAuth.",
  "docs.python.title": "Exemple · Python",
  "docs.python.body":
    "Nécessite un **client OAuth de type Application de bureau** dans Google Cloud Console (distinct du client Web utilisé par la SPA). Au premier lancement, le script ouvre une fois un onglet du navigateur ; les exécutions suivantes réutilisent automatiquement le jeton de rafraîchissement enregistré.",
  "docs.s2s.title": "Serveur à serveur (compte de service)",
  "docs.s2s.body":
    "Pour les intégrations backend, créez un **compte de service** Google Cloud, ajoutez son e-mail (`name@project.iam.gserviceaccount.com`) à la liste autorisée et utilisez `google.oauth2.service_account.IDTokenCredentials` avec `target_audience` défini sur notre OAuth Client ID. Le jeton ID généré fonctionne de la même manière.",
  "docs.copy": "COPIER",
  "docs.copied": "COPIÉ",
};
